(function () {
  // Guard against the file being evaluated twice (e.g. theme editor reloads)
  if (window.__marqueeTextLoaded) return;
  window.__marqueeTextLoaded = true;

  var SELECTOR = '[data-marquee]';
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Clone the original group until the track is 2x what's needed to fill the container
  function build(el) {
    var track = el.querySelector('.marquee__track');
    var original = track && track.querySelector('.marquee__group:not([data-clone])');
    if (!original) return;

    // Reset any previous build
    track.querySelectorAll('[data-clone]').forEach(function (node) { node.remove(); });
    el.classList.remove('is-ready');

    // Respect reduced motion: leave a static, scrollable row
    if (reducedMotion.matches) return;

    var groupWidth = original.getBoundingClientRect().width;
    if (!groupWidth) return;

    // Copies needed to cover the container, then doubled for the -50% loop
    var copies = Math.max(1, Math.ceil(el.clientWidth / groupWidth));
    for (var i = 1; i < copies * 2; i++) {
      var clone = original.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-clone', '');
      // Keep duplicate links out of the tab order
      clone.querySelectorAll('a').forEach(function (a) { a.setAttribute('tabindex', '-1'); });
      track.appendChild(clone);
    }

    // Convert px/second speed into a duration for the distance traveled
    var speed = parseFloat(el.dataset.speed) || 60;
    el.style.setProperty('--marquee-duration', (groupWidth * copies) / speed + 's');
    el.classList.add('is-ready');
  }

  function init(el) {
    if (el.dataset.marqueeInit) return;
    el.dataset.marqueeInit = 'true';

    var lastWidth = el.clientWidth;
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () {
        // Only rebuild when the width actually changes
        if (el.clientWidth !== lastWidth) {
          lastWidth = el.clientWidth;
          build(el);
        }
      }).observe(el);
    }

    build(el);

    // Web fonts change text width, so rebuild once they've loaded
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { build(el); });
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added or its settings change
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  // Rebuild if the user toggles reduced motion while the page is open
  reducedMotion.addEventListener('change', function () {
    document.querySelectorAll(SELECTOR).forEach(build);
  });
})();
